import {
  ComponentConfig,
  ComponentType,
  FlexDirection,
  LayoutTypes,
} from "../services/types/ComponentTypes";

/** Tab hub shell — summary content injected at runtime from API configs 187/192. */
export const screen_196_bill_allocations_hub: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    screenId: "196",
    title: "Bill wise allocations",
    style: {
      backgroundColor: "#F9FAFB",
    },
    childComponents: [
      {
        componentType: ComponentType.CUSTOM,
        customType: "billAllocationTabs",
      },
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12,
          padding: 16,
        },
        childComponents: [],
      },
    ],
  },
];
